export enum CustomCssClassNames {
    TOP_NAVIGATION = 'top-navigation',
    ACTIVE = 'active',
    DISABLED = 'disabled',
    SELECTED = 'selected',
    ODDS_TABS = 'odds-tabs',
    ODD_ITEM_DROPDOWN = 'odd-item-dropdown',
    ODD_ITEM_DROPDOWN_CONFIRM = 'odd-item-dropdown-confirm',
    ODD_ITEM = 'odd-item',
    ODD_ITEM_VALUE = 'odd-item-info',
    ODD_ITEM_STATUS = 'odd-value',
    FAVOURITE_TOGGLE = 'favourite-toggle',
    GAME_LINK = 'game-link',
    GAME_LINK_CIRCLE = 'game-link-circle',
    BET_SLIP = 'bet-slip',
    BET_SLIP_INPUT_CONTAINER = 'bet-slip-input-container',
    BET_SLIP_INPUT = 'bet-slip-input',
    BET_SLIP_AMOUNT_BUTTON = 'bet-slip-amount-button',
    BET_SLIP_HEADER = 'bet-slip-header',
    BET_SLIP_TYPE_LABEL_CONTAINER = 'bet-slip-type-label-container',
    BET_SLIP_TYPE_LABEL = 'bet-slip-type-label',
    BET_SLIP_EMPTY = 'bet-slip-empty',
    BET_SLIP_TAX = 'bet-slip-tax',
    BET_SLIP_TAX_LINE_BREAK = 'bet-slip-tax-line-break',
    NUMPAD = 'numpad',
    NUMPAD_KEY = 'numpad-key',
    NUMPAD_TOGGLE = 'numpad-toggle',
    PLACE_BET_BUTTON = 'place-bet-button',
    SELECTED_ODDS_LIST = 'selected-odds-list',
    SELECTED_ODD = 'selected-odd',
    SELECTED_ODD_INFO = 'selected-odd-info',
    SELECTED_ODD_MESSAGE = 'selected-odd-message',
    MOBILE_BETTING = 'mobile-betting',
    BET_ITEM = 'bet-item',
    BET_ITEM_LINK = 'bet-item-link',
    BETS_HISTORY_TABLE = 'bets-history-table',
    BETS_HISTORY_TABLE_MOBILE = 'bets-history-table-mobile',
    REPORT = 'report',
    RECENT_BET = 'recent-bet',
    RECENT_BET_AMOUNT = 'recent-bet-amount',
    RECENT_BETS = 'recent-bets',
    HEADER_TITLE = 'header-title',
    HEADER_FILTER = 'header-filter',
    HEADER_FILTERS = 'header-filters',
    HEADER_FILTERS_TOGGLE = 'header-filters-toggle',
    GAME_DROPDOWN = 'game-dropdown',
    RUN_INPUT = 'run-input',
    GAMES_NAVIGATION = 'games-navigation',
    GAME_TITLE = 'game-title',
    TABS = 'tabs',
    TABS_BAR_ARROW = 'tabs-bar-arrow',
    TABS_BAR_ITEM = 'tabs-bar-item',
    TABS_DEFAULT = 'tabs-default',
    TABS_SUB = 'tabs-sub',
    REPEAT_BETS = 'repeat-bets',
    DATEPICKER = 'datepicker',
    CURTAIN = 'curtain',
    GAME_INFORMATION_HEADER = 'game-information-header',
    LAST_RESULTS = 'last-results',
    VIDEO = 'video',
    VIDEO_LOGO = 'video-logo',
    NOTIFICATION_DOT = 'notification-dot',
    PAGINATION = 'pagination',
    PAGINATION_ITEM = 'pagination-item',
    PANEL_HEADER = 'panel-header',
    DROPDOWN_BUTTON = 'dropdown-button',
    DROPDOWN_CONTENT = 'dropdown-content',
}
